<div class="p-4 flex flex-col gap-4 max-h-[85vh] overflow-hidden">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-subtitle color-blue">Configurar encabezados</p>

    <button
      (click)="closeModal()"
      class="flex! justify-center! items-center!"
      color="primary"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="mx-4 rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-200 text-general-subtitle text-primary!">
      Encabezados originales
    </div>

    <div
      cdkDropList
      [cdkDropListData]="headerOptions"
      (cdkDropListDropped)="drop($event)"
      class="space-y-2 max-h-[60vh] overflow-y-auto overflow-x-hidden p-4 pr-3"
    >
      @for (header of headerOptions; track header.value) {
        <div
          cdkDrag
          [cdkDragDisabled]="isLocked(header)"
          class="flex items-center justify-between p-2 rounded bg-white shadow-sm border border-gray-200 gap-3"
        >
          <div class="flex items-center gap-2 min-w-0">
            <button
              mat-icon-button
              color="primary"
              cdkDragHandle
              [disabled]="isLocked(header)"
              aria-label="Mover encabezado"
            >
              ☰
            </button>

            <div class="min-w-0">
              <div class="truncate">{{ header.order }}. {{ header.description }}</div>
              <div class="text-xs text-slate-500 truncate">{{ header.value }}</div>
              @if (isLocked(header)) {
                <div class="text-xs text-slate-500">{{ lockLabel(header) }}</div>
              }
            </div>
          </div>

          <mat-checkbox [(ngModel)]="header.visible" [disabled]="isLocked(header)">
            Mostrar
          </mat-checkbox>
        </div>
      }
    </div>
  </div>

  <button
    (click)="save()"
    class="bg-(--brand-azul-primario)! text-white! text-sm! rounded-xl px-4! py-2! w-auto! m-auto! flex! items-center! justify-center! gap-2"
    mat-button
  >
    Guardar cambios
  </button>
</div>
